export const calcEnergySavings = (coolingHrs, electRate, eqiupBtu, curSeer, newSeer) => {
  const discount_rate = 0.03;
  const units_quantity = 1;
  const electric_rate = parseFloat(electRate / 100);
  const equipment_btu = parseFloat(eqiupBtu);
  const cooling_hours = parseFloat(coolingHrs);
  const current_seer = parseFloat(curSeer);
  const new_seer = parseFloat(newSeer);
  const current_kwh = (units_quantity * (equipment_btu / current_seer) * cooling_hours) / 1000; //kWh for Current AC
  const current_cost = Math.round(current_kwh * electric_rate); //Annual Cost for Current AC
  const newest_kwh = (units_quantity * (equipment_btu / new_seer) * cooling_hours) / 1000; //kWh for New AC
  const newest_cost = Math.round(newest_kwh * electric_rate); //Annual Cost for New AC

  const saved = current_cost - newest_cost; // Energy Cost Saving in USD
  const savperiod = (saved * 100) / current_cost; // Energy Cost Savings in Percent

  return {
    '5yr': formatResult(PV(discount_rate, 5, saved)),
    '10yr': formatResult(PV(discount_rate, 10, saved)),
    '15yr': formatResult(PV(discount_rate, 15, saved)),
    SavingsPctPerYr: formatResult(savperiod, 1),
    CurrentAnnualCost: formatResult(current_cost),
    NewAnnualCost: formatResult(newest_cost),
  };
};

const formatResult = val => Math.round(val).toLocaleString();

const PV = (rate, nper, pmt) => (pmt / rate) * (1 - Math.pow(1 + rate, -nper));
